import { render } from "./configDropdown.vue?vue&type=template&id=47ed9c28&scoped=true"
import script from "./configDropdown.vue?vue&type=script&lang=js"
export * from "./configDropdown.vue?vue&type=script&lang=js"

import "./configDropdown.vue?vue&type=style&index=0&id=47ed9c28&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47ed9c28"]])

export default __exports__